import api from '../api'
import { CurrentUser } from '../currentUser'

export function loadPartnerUsers(partnerId: string): Promise<Array<CurrentUser>> {
    return api({ path: `/partners/${partnerId}/users` })
}
